import React, { useState } from 'react'

import JobList from './jobs'
import TaskList from './tasks'
import QuoteList from './quotes'

import { LAYOUT_MANAGER_JOB_SHOW, LAYOUT_MANAGER_QUOTE_SHOW } from '../../navigation'
import Modal from '../../../../components/job/modal'

import CustomPanel from './collapse'
import Loader from '../../../../components/loader'

import {
  useFetchHomeTasks,
  useFetchHomeJobs,
  useFetchHomeQuotes,

  getJobsInProgress,
  getJobsWithUpcomingDeadline,
  getJobsWaitingConfirmation,

  getTasksUnassigned,
  getTasksWaitingConfirmation,
  getTasksWithUpcomingDeadline,

  getQuotesInProgress

} from '../../../../hooks/manager/home'
import { useHistory } from 'react-router-dom'

const UnassignedIcon = require('../../../../assets/icons/unassigned.png')
const OfferedIcon = require('../../../../assets/icons/confirmation.png')
const ConfirmationIcon = require('../../../../assets/icons/confirmation.png')
const InProgressIcon = require('../../../../assets/icons/in-progress.png')
const DeadlineIcon = require('../../../../assets/icons/deadline.png')
const QuotesIcon = require('../../../../assets/icons/quotes.png')

const Dashboard = (props) => {
  const history = useHistory()
  const [modalVisible, setModalVisible] = useState(false)
  const [modalId, setModalId] = useState(null)

  const { data: tasks, isLoading: isTasksLoading, isError: isTasksError } = useFetchHomeTasks(props.query)
  const { data: jobs, isLoading: isJobsLoading, isError: isJobsError } = useFetchHomeJobs(props.query)
  const { data: quotes, isLoading: isQuotesLoading, isError: isQuotesError } = useFetchHomeQuotes(props.query)

  if (isTasksLoading || isJobsLoading || isQuotesLoading) {
    return (<Loader loading />)
  }

  if (isTasksError || isJobsError || isQuotesError) {
    return (<>Error</>)
  }

  const jobsWaitingConfirmation = getJobsWaitingConfirmation(jobs)
  const jobsInProgress = getJobsInProgress(jobs)
  const jobsUpcomingDeadline = getJobsWithUpcomingDeadline(jobs)

  const unassigned = getTasksUnassigned(tasks)
  const offered = getTasksWaitingConfirmation(tasks)
  const upcoming = getTasksWithUpcomingDeadline(tasks)

  const quotesInProgress = getQuotesInProgress(quotes)

  const viewJob = (id) => {
    setModalId(id)
    setModalVisible(true)
  }

  const hideModal = () => {
    setModalVisible(false)
    setModalId(null)
  }

  const loading = isJobsLoading || isQuotesLoading || isTasksLoading
  const error = isJobsError || isQuotesError || isTasksError

  /**
   * Jobs variables
   */

  const countWaitingConfirmation = (jobsWaitingConfirmation || []).length
  const countInProgress = (jobsInProgress || []).length
  const countUpcomingClientDDL = (jobsUpcomingDeadline || []).length

  /**
   * Tasks variables
   */

  const countUnassigned = (unassigned || []).length
  const countOffered = (offered || []).length
  const countUpcomingVendorDDL = (upcoming || []).length

  /**
   * Quotes variables
   */
  const countQuotesInProgress = (quotesInProgress || []).length

  const viewMore = (id) => history.push(LAYOUT_MANAGER_JOB_SHOW(id))
  const viewMoreQuote = (id) => history.push(LAYOUT_MANAGER_QUOTE_SHOW(id))
  const quickView = (id) => viewJob(id)

  return (
    <>
      <CustomPanel
        count={countUnassigned}
        type='info'
        icon={UnassignedIcon}
        title='Unassigned Tasks.'
        error={error}
        loading={loading}
      >
        <TaskList
          list={unassigned}
          quickView={quickView}
          viewMore={viewMore}
        />
      </CustomPanel>

      <CustomPanel
        count={countOffered}
        type='info'
        icon={OfferedIcon}
        title='Offered to Vendors'
        error={error}
        loading={loading}
      >
        <TaskList
          list={offered}
          quickView={quickView}
          viewMore={viewMore}
        />
      </CustomPanel>

      <CustomPanel
        count={countUpcomingVendorDDL}
        type='info'
        icon={DeadlineIcon}
        title='Upcoming Vendor DDL.'
      >
        <TaskList
          list={upcoming}
          error={error}
          loading={loading}
          quickView={quickView}
          viewMore={viewMore}
        />
      </CustomPanel>

      <br />

      <CustomPanel
        count={countQuotesInProgress}
        type='info'
        icon={QuotesIcon}
        title='Quotes in Progress.'
        error={error}
        loading={loading}
      >
        <QuoteList
          list={quotesInProgress}
          viewMore={viewMoreQuote}
        />
      </CustomPanel>

      <CustomPanel
        count={countWaitingConfirmation}
        type='info'
        icon={ConfirmationIcon}
        title='Client is waiting for a confirmation.'
        error={error}
        loading={loading}
      >
        <JobList
          list={jobsWaitingConfirmation}
          quickView={quickView}
          viewMore={viewMore}
        />
      </CustomPanel>

      <CustomPanel
        count={countInProgress}
        type='info'
        icon={InProgressIcon}
        title='Jobs in Progress.'
        error={error}
        loading={loading}
      >
        <JobList
          list={jobsInProgress}
          quickView={quickView}
          viewMore={viewMore}
        />
      </CustomPanel>

      <CustomPanel
        count={countUpcomingClientDDL}
        type='info'
        icon={DeadlineIcon}
        title='Upcoming Client DDL.'
        error={error}
        loading={loading}
      >
        <JobList
          list={jobsUpcomingDeadline}
          quickView={quickView}
          viewMore={viewMore}
        />
      </CustomPanel>

      <Modal visible={modalVisible} id={modalId} onCancel={hideModal} />
    </>
  )
}

export default Dashboard
